import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "fe_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [showPrefs, setShowPrefs] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [marketing, setMarketing] = useState(false);

  useEffect(() => {
    try {
      const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
      if (!stored) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const persist = (prefs) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ necessary: true, ...prefs, ts: Date.now() }));
    setVisible(false);
    setShowPrefs(false);
  };

  const acceptAll = () => persist({ analytics: true, marketing: true });
  const rejectNonEssential = () => persist({ analytics: false, marketing: false });
  const saveCustom = () => persist({ analytics, marketing });

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-forest text-white border-t border-white/10">
      <div className="mx-auto max-w-6xl px-6 py-5">
        {!showPrefs ? (
          <div className="flex flex-col md:flex-row md:items-center gap-4 justify-between">
            <p className="text-sm text-white/90 max-w-2xl">
              We use cookies to run this site and, with your consent, for analytics and
              marketing (including offers from our parent company, Corporate Office Furniture
              Ltd). See our{" "}
              <Link to="/cookies" className="underline hover:text-safety">Cookie Policy</Link>.
            </p>
            <div className="flex flex-wrap gap-3">
              <button
                onClick={() => setShowPrefs(true)}
                className="h-10 px-4 border border-white/40 hover:border-white text-sm font-display"
              >
                Manage preferences
              </button>
              <button
                onClick={rejectNonEssential}
                className="h-10 px-4 border border-white/40 hover:border-white text-sm font-display"
              >
                Reject non-essential
              </button>
              <button
                onClick={acceptAll}
                className="h-10 px-5 bg-safety text-forest hover:bg-safety/90 text-sm font-display font-medium"
              >
                Accept all
              </button>
            </div>
          </div>
        ) : (
          <div className="space-y-4">
            <p className="text-sm text-white/90">Choose which cookies you're happy for us to use.</p>
            <div className="grid gap-3 sm:grid-cols-3">
              <label className="flex items-center gap-2 text-sm">
                <input type="checkbox" checked disabled className="h-4 w-4" />
                Strictly necessary
              </label>
              <label className="flex items-center gap-2 text-sm">
                <input
                  type="checkbox"
                  checked={analytics}
                  onChange={(e) => setAnalytics(e.target.checked)}
                  className="h-4 w-4"
                />
                Analytics
              </label>
              <label className="flex items-center gap-2 text-sm">
                <input
                  type="checkbox"
                  checked={marketing}
                  onChange={(e) => setMarketing(e.target.checked)}
                  className="h-4 w-4"
                />
                Marketing
              </label>
            </div>
            <div className="flex flex-wrap gap-3">
              <button
                onClick={() => setShowPrefs(false)}
                className="h-10 px-4 border border-white/40 hover:border-white text-sm font-display"
              >
                Back
              </button>
              <button
                onClick={saveCustom}
                className="h-10 px-5 bg-safety text-forest hover:bg-safety/90 text-sm font-display font-medium"
              >
                Save preferences
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
